let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6TrIG")).then(() => parcelRequire('g3f2f'));